const listeners = new Set<() => void>()
const pending = new Set<symbol>()
let visible = false
let delay: ReturnType<typeof setTimeout> | undefined

export const isPageLoading = () => visible
export const subscribePageLoading = (listener: () => void) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

function publish(next: boolean) {
  if (visible === next) return
  visible = next
  listeners.forEach(listener => listener())
}

/** Each operation owns its cleanup, so concurrent loads cannot clear one another. */
export function beginPageLoad() {
  if (typeof window === 'undefined') return () => {}
  const token = Symbol()
  pending.add(token)
  if (!visible && delay === undefined) {
    delay = setTimeout(() => {
      delay = undefined
      publish(pending.size > 0)
    }, 250)
  }
  return () => {
    if (!pending.delete(token) || pending.size > 0) return
    clearTimeout(delay)
    delay = undefined
    publish(false)
  }
}

export async function withPageLoading<T>(load: () => Promise<T>): Promise<T> {
  const finish = beginPageLoad()
  try {
    return await load()
  } finally {
    finish()
  }
}
